<template>
    <div>
        <!-- page header -->
        <backButton />

        <br />

        <v-card class="elevation-5 pl-1 pb-4">
            <!-- card title -->
            <v-card-title>
                <h2 class="card__title">Введите реквизиты карты</h2>
            </v-card-title>

            <!-- card body -->
            <v-form class="px-4" ref="paymentForm">
                <v-flex xs12 sm7 md7 lg7>
                    <!-- amount -->
                    <div class="d-flex my-2">
                        <v-text-field
                            v-model="form.amount"
                            v-bind:rules="[rules.required]"
                            validate-on-blur
                            label="Сумма платежа, руб"
                            required
                            mask="######"
                            color="indigo_6"
                            outline
                        ></v-text-field>
                    </div>

                    <!-- card number -->
                    <div class="d-flex my-2">
                        <v-text-field
                            v-model="form.cardNumber"
                            v-bind:rules="[rules.required]"
                            validate-on-blur
                            label="Номер карты"
                            required
                            mask="credit-card"
                            color="indigo_6"
                            outline
                        ></v-text-field>
                    </div>

                    <!-- card name -->
                    <div class="d-flex my-2">
                        <v-text-field
                            v-model="form.cardName"
                            v-bind:rules="[rules.required]"
                            validate-on-blur
                            label="Имя владельца"
                            required
                            color="indigo_6"
                            outline
                        ></v-text-field>
                    </div>

                    <!-- expire date -->
                    <div class="d-flex">
                        <v-text-field
                            class="mr-2"
                            v-model="form.expireDate"
                            v-bind:rules="[rules.required]"
                            validate-on-blur
                            label="Срок действия"
                            mask="## / ##"
                            required
                            color="indigo_6"
                            outline
                        ></v-text-field>

                        <!-- CVV code -->
                        <v-text-field
                            v-model="form.cvv"
                            v-bind:rules="[rules.required]"
                            validate-on-blur
                            label="CVV"
                            mask="###"
                            color="indigo_6"
                            outline
                        ></v-text-field>
                    </div>

                    <!-- save My Card Detials -->
                    <div class="d-flex">
                        <v-checkbox
                            v-model="form.cardSave"
                            label="Запомнить карту"
                            color="indigo_6"
                        ></v-checkbox>
                    </div>
                </v-flex>
            </v-form>

            <!-- card button -->
            <v-card-actions>
                <v-btn
                    class="btn ml-2"
                    color="indigo_5"
                    large
                    dark
                    v-on:click="validate"
                    >Оплатить</v-btn
                >
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import backButton from '@/components/backButton';
export default {
    components: { backButton },

    data: () => ({
        valid: false,

        form: {
            amount: '',
            cardNumber: '',
            cardName: '',
            expireDate: '',
            cvv: '',
            cardSave: '',
        },

        rules: {
            required: (value) => !!value || 'Это обязательное поле',
        },
    }),

    methods: {
        validate() {
            if (this.$refs.paymentForm.validate()) {
                // this.$store.dispatch("", this.form);
                console.log(this.form);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';
</style>
